import { Box, Flex, Portal } from "@chakra-ui/react";
import { KpecDashboard } from "@root/components/kpecDashboard";
import { useJournalistDashboardTourGuide } from "@root/hooks/useJournalistDashboardTourGuide";
import { TourGuide, RestartTourButton } from "@root/components/tour-guide";

export const UserProjectsDashboard = () => {
  const { journalistDashboardTourGuide } = useJournalistDashboardTourGuide();

  return (
    <Box width="100%" height="100%" position="relative" className="projectsDashboard">
      <Flex minW="100%" position="relative">
        <KpecDashboard />
      </Flex>

      {!journalistDashboardTourGuide.isActive && (
        <Portal>
          <RestartTourButton
            onClick={journalistDashboardTourGuide.startTour}
            position={{ bottom: "24px", right: "24px" }}
          />
        </Portal>
      )}

      {journalistDashboardTourGuide.isActive &&
        journalistDashboardTourGuide.currentStepData && (
          <TourGuide
            isActive={journalistDashboardTourGuide.isActive}
            currentStep={journalistDashboardTourGuide.currentStepData}
            currentStepIndex={journalistDashboardTourGuide.currentStep}
            totalSteps={journalistDashboardTourGuide.totalSteps}
            onNext={journalistDashboardTourGuide.nextStep}
            onBack={journalistDashboardTourGuide.previousStep}
            onClose={journalistDashboardTourGuide.stopTour}
            targetSelector={journalistDashboardTourGuide.currentStepData.targetSelector}
            borderRadius="8px"
          />
        )}
    </Box>
  );
};
